function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-928 -1013)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  transform: "translate(928 1013)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#09bfec"
}, /*#__PURE__*/React.createElement("path", {
  d: "M960 1020.425a25 25 0 11-25 25 25 25 0 0125-25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M933 1045.673A26.673 26.673 0 10959.673 1019 26.669 26.669 0 00933 1045.673zm42.625-15.948a22.561 22.561 0 11-31.9 31.9 22.561 22.561 0 1131.9-31.9z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M945.717 1037.733a2.485 2.485 0 000 3.5l12.276 12.234a2.472 2.472 0 003.411.077l12.093-12.057a2.471 2.471 0 10-3.488-3.5l-10.392 10.236-10.4-10.5a2.473 2.473 0 00-3.5.01z",
  fill: "#fff"
}));

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTI4IC0xMDEzKSI+PGNpcmNsZSBjeD0iMzIiIGN5PSIzMiIgcj0iMzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkyOCAxMDEzKSIgZmlsbD0iI2ZmZiIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC40MjUpIj48cGF0aCBkPSJNMjUsMEEyNSwyNSwwLDEsMSwwLDI1LDI1LDI1LDAsMCwxLDI1LDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5MzUgMTAyMCkiIGZpbGw9IiMwOWJmZWMiLz48cGF0aCBkPSJNMy4zNzUsMzAuMDQ4QTI2LjY3MywyNi42NzMsMCwxLDAsMzAuMDQ4LDMuMzc1LDI2LjY2OSwyNi42NjksMCwwLDAsMy4zNzUsMzAuMDQ4Wk00NiwxNC4xQTIyLjU2MSwyMi41NjEsMCwxLDEsMTQuMSw0NiwyMi41NjEsMjIuNTYxLDAsMSwxLDQ2LDE0LjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5MjkuNjI1IDEwMTUuMikiIGZpbGw9IiMwOWJmZWMiLz48L2c+PHBhdGggZD0iTTEwLjcsMTUuMTQ2YTIuNDg1LDIuNDg1LDAsMCwwLDAsMy41TDIyLjk3NiwzMC44OGEyLjQ3MiwyLjQ3MiwwLDAsMCwzLjQxMS4wNzdMMzguNDgsMTguOWEyLjQ3MSwyLjQ3MSwwLDEsMC0zLjQ4OC0zLjVMMjQuNiwyNS42MzZsLTEwLjQtMTAuNUEyLjQ3MywyLjQ3MywwLDAsMCwxMC43LDE1LjE0NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkzNS4wMTcgMTAyMi41ODcpIiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==";
export { SvgArrowDown as ReactComponent };